import React from "react";
import Button from '@mui/material/Button';
import PatientAction from "./patientActionButtons";


const VitalParameter = () => {
    return (
        <><PatientAction />
        <form>
            <div className="vital-info" >
                <div className="mt-3 ml-4"> <h4>Vital Parmeter</h4></div>
                <div className="row" style={{ marginLeft:0, marginRight: 0 }}>
                    <div className="form-group col-md-6">
                        <label for="fname" className="control-label col-sm">Height</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="fname" placeholder="Height" />
                        </div>
                    </div>
                     <div className="form-group col-md-6">
                        <label for="lname" className="control-label col-sm">Weight</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="lname" placeholder="Weight" />
                        </div>
                    </div>
                   <div className="form-group col-md-6">
                        <label for="fname" className="control-label col-sm">BMI (Auto calculate)</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="fname" placeholder="BMI (Auto calculate)" />
                        </div>
                    </div>
                    <div className="form-group col-md-6">
                        <label for="lname" className="control-label col-sm">Blood Group</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="lname" placeholder="Blood Group" />
                        </div>
                    </div>
                    <div className="form-group col-md-6">
                        <label for="fname" className="control-label col-sm">Allergy</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="fname" placeholder="Allergy" />
                        </div>
                    </div>
                    <div className="form-group col-md-6">
                        <label for="lname" className="control-label col-sm">BP</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="lname" placeholder="BP" />
                        </div>
                    </div>
                   
                </div>
            </div>
            <div className="d-flex justify-content-end mr-4 mb-3">
                <Button variant="outlined">Submit</Button>
            </div>
        </form>
        </>
    );
};

export default VitalParameter; 